var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashCricle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 57,
    viewBox: "0 0 58 57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "t0ksu17iia",
    x1: "75.624%",
    x2: "24.703%",
    y1: "-9.211%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38EA42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#15AD7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#15AD7B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.675 .233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.254,
    cy: 28.254,
    r: 28.254,
    fill: "url(#t0ksu17iia)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M34.748 33.83v-1.12l5.154-3.305.812.576-5.966 3.848zm-11.317 7.268c-.072.052-.18.097-.292.006l-7.354-5.3.76-.494 5.896 4.249c.243.195.533.294.826.294.274 0 .553-.087.8-.257l6.234-3.99v1.092l-.591.381.001.002-6.28 4.017zm-.99-4.069c.24.194.534.296.847.296.252 0 .516-.066.776-.202l6.237-3.942v.992l-6.87 4.396c-.072.053-.18.096-.292.007l-6.162-4.44a.559.559 0 00-.147-.107l-1.045-.754.76-.494 5.896 4.248zm-.086-10.537l7.507 5.538-6.368 4.027c-.048.027-.216.101-.355-.011l-6.16-4.439a.594.594 0 00-.15-.108l-1.043-.752 6.569-4.255zm11.091-9.49l7.53 5.459c-1.681 2.453-4.123 4.813-6.806 6.59l-7.482-5.376c2.62-1.768 5.03-4.141 6.758-6.673zM31.471 32.01c0-.006-.004-.012-.005-.02a.608.608 0 00-.235-.448l-7.796-5.75 2.172-1.409 7.964 5.721v4.485l-2.093 1.35v-3.9c0-.01-.006-.018-.007-.029zm3.277-.736v-1.16a27.497 27.497 0 004.509-3.725l1.463 1.057-5.972 3.828zm6.249-2.572l1.104-.707a.621.621 0 00.028-1.02L40.09 25.5a22.979 22.979 0 002.192-2.856.622.622 0 00-.152-.837l-8.496-6.158a.574.574 0 00-.827.163c-1.35 2.107-3.214 4.128-5.301 5.78l-.073.054a23.74 23.74 0 01-.984.736c-.357.252-.72.494-1.087.72 0 .002 0 .003-.002.003l-.005.004-10.949 7.092a.618.618 0 00-.278.503.616.616 0 00.253.516l1.115.802-1.091.71a.62.62 0 00-.024 1.017l1.115.803-1.091.707a.616.616 0 00-.277.503.616.616 0 00.253.516l8.06 5.809c.244.195.534.293.827.293.274 0 .553-.086.8-.257l7.13-4.563c.01-.005.014-.014.023-.02l10.882-7.018c.17-.109.273-.3.278-.505a.617.617 0 00-.255-.516l-1.128-.8z"
  })))))))));
}
SvgCashCricle.displayName = 'CashCricle';
export default SvgCashCricle;